import React from 'react'
import { FormattedMessage } from 'react-intl'
import { AttackStatus, attackStatusi18nConfig } from '../attack-status'
import { Badge, BadgeColors } from '@contrast-security-inc/design-system-badges'
import {
  Text,
  TextColors
} from '@contrast-security-inc/design-system-typography'

const attackStatusColorConfig: Record<AttackStatus, BadgeColors> = {
  [AttackStatus.BLOCKED]: 'green50',
  [AttackStatus.BLOCKED_PERIMETER]: 'green30',
  [AttackStatus.PROBED]: 'neutral40',
  [AttackStatus.PROBED_PERIMETER]: 'neutral90',
  [AttackStatus.EXPLOITED]: 'red50',
  [AttackStatus.SUSPICIOUS]: 'yellow50'
}

const attackStatusTextColor: Record<AttackStatus, TextColors> = {
  [AttackStatus.BLOCKED]: 'black',
  [AttackStatus.BLOCKED_PERIMETER]: 'black',
  [AttackStatus.PROBED]: 'black',
  [AttackStatus.PROBED_PERIMETER]: 'white',
  [AttackStatus.EXPLOITED]: 'white',
  [AttackStatus.SUSPICIOUS]: 'black'
}

interface AttackStatusProps {
  readonly status: AttackStatus
}

export function AttackStatusBadge({ status }: AttackStatusProps) {
  const i18nID = attackStatusi18nConfig[status]
  const backgroundColor = attackStatusColorConfig[status]
  const textColor = attackStatusTextColor[status]

  return (
    <FormattedMessage id={i18nID}>
      {(text) => (
        <Badge color={backgroundColor} variant="Normal">
          <Text font="labelSm" color={textColor}>
            {text}
          </Text>
        </Badge>
      )}
    </FormattedMessage>
  )
}
